// extracted by mini-css-extract-plugin
export var container = "_m5-0";
export var dotAnimation = "_m5-2";
export var dotsLoading = "_m5-1";